import React from "react";
import ProjectOverview from "../ProjectOverview";

const ProjectOverviewWidget = ({ contracts, employees, products, invoices }) => (
  <div className="widget-content-scroll">
    <ProjectOverview
      contracts={contracts || []}
      employees={employees || []}
      products={products || []}
      invoices={invoices || []}
    />
  </div>
);

export default ProjectOverviewWidget;
